import { atomWithKey as atom } from "./atomWithKey";
import { ICmsAboutPass, ICmsMonthlyPassOfferResponse, ICmsOffers, ICmsTravelPassOfferResponse } from "../Types/Interface/ICMSOffers";
import { ICmsAccountBanner } from "../Types/Interface/ICmsAccountBanner";

export const cmsOfferListAtom = atom<ICmsOffers[]>({
  key: "cmsOfferListAtom",
  default: [],
});
export const cmsOfferDetailAtom = atom<ICmsOffers | null>({
  key: "cmsOfferDetailAtom",
  default: null,
});

export const cmsMonthlyPassOfferResponseAtom = atom<ICmsMonthlyPassOfferResponse | null>({
  key: "cmsMonthlyPassOfferResponseAtom",
  default: null,
});

export const cmsTravelPassOfferResponseAtom = atom<ICmsTravelPassOfferResponse | null>({
  key: "cmsTravelPassOfferResponseAtom",
  default: null,
});

export const cmsSpecialFareOfferResponseAtom = atom<ICmsTravelPassOfferResponse | null>({
  key: "cmsSpecialFareOfferResponseAtom",
  default: null,
});

export const cmsSpecialFareOfferDetailResponseAtom = atom<ICmsOffers | null>({
  key: "cmsSpecialFareOfferDetailResponseAtom",
  default: null,
});

export const cmsAboutPassDetailAtom = atom<ICmsAboutPass | null>({
  key: "cmsAboutPassDetailAtom",
  default: null,
});

export const cmsAccountBannerAtom = atom<ICmsAccountBanner | null>({
  key: "cmsAccountBannerAtom",
  default: null,
});
